import React from "react";
import {
  PanelBody,
  PanelRow,
  BaseControl,
  TextControl,
  Button,
  ExternalLink,
} from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import { useState, useEffect } from "@wordpress/element";

import useSettings from "../utils/useSettings";
const integrations = () => {
  const [getOption, updateOption, status] = useSettings();
  const [googleMapsAPI, setGoogleMapsAPI] = useState("");
  const [mailchimpAPI, setMailchimpAPI] = useState("");
  const [mailchimpAudienceID, setMailchimpAudienceID] = useState("");
  const [weatherAPI, setWeatherAPI] = useState("");

  useEffect(() => {
    setGoogleMapsAPI(getOption("slideverse_google_maps_api_key"));
    setWeatherAPI(getOption("slideverse_open_weather_map_api_key"));
    setMailchimpAPI(getOption("slideverse_mailchimp_api_key"));
    setMailchimpAudienceID(getOption("slideverse_mailchimp_audience_id"));
  }, [
    getOption("slideverse_google_maps_api_key"),
    getOption("slideverse_mailchimp_api_key"),
    getOption("slideverse_mailchimp_audience_id"),
    getOption("slideverse_open_weather_map_api_key"),
  ]);

  return (
    <>
      <PanelBody title={__("Google Maps", "slideverse")}>
        <PanelRow>
          <BaseControl
            label={__("Google Maps API", "slideverse")}
            help={__(
              "In order to use Google Maps block, you need to use Google Maps and Places API.",
              "slideverse"
            )}
            id="slideverse-options-google-map-api"
            className="slideverse-button-field"
          >
            <TextControl
              type="text"
              label={__("Secret Key", "slideverse")}
              value={googleMapsAPI}
              placeholder={__("Google Maps API Key", "slideverse")}
              disabled={"saving" === status}
              onChange={(value) => setGoogleMapsAPI(value)}
            />

            <div className="slideverse-button-group">
              <Button
                variant="secondary"
                className="ubs-action-button"
                isSecondary
                disabled={"saving" === status}
                onClick={() =>
                  updateOption("slideverse_google_maps_api_key", googleMapsAPI)
                }
              >
                {__("Save", "slideverse")}
              </Button>

              <ExternalLink href="https://developers.google.com/maps/documentation/javascript/get-api-key">
                {__("Get API Key", "slideverse")}
              </ExternalLink>
            </div>
          </BaseControl>
        </PanelRow>
      </PanelBody>
      <PanelBody
        title={__("Weather API (Coming Soon...)", "slideverse")}
        initialOpen={true}
      >
        <PanelRow>
          <BaseControl
            label={__("Weather API", "slideverse")}
            help={__(
              "In order to use Weather block, you need to use Weather API.",
              "slideverse"
            )}
            id="slideverse-options-weather-api"
            className="slideverse-button-field"
          >
            <TextControl
              type="text"
              label={__("Secret Key", "slideverse")}
              value={weatherAPI}
              placeholder={__("Weather API Key", "slideverse")}
              disabled={true}
              onChange={(value) => setWeatherAPI(value)}
            />

            <div className="slideverse-button-group">
              <Button
                variant="secondary"
                className="ubs-action-button"
                isSecondary
                disabled={true}
                onClick={() =>
                  updateOption(
                    "slideverse_open_weather_map_api_key",
                    weatherAPI
                  )
                }
              >
                {__("Save", "slideverse")}
              </Button>

              <ExternalLink href="https://home.openweathermap.org/api_keys">
                {__("Get API Key", "slideverse")}
              </ExternalLink>
            </div>
          </BaseControl>
        </PanelRow>
      </PanelBody>
      <PanelBody title={__("Mailchimp (NEWSLETTER)", "slideverse")} initialOpen={false}>
        <PanelRow>
          <BaseControl
            label={__("Mailchimp API", "slideverse")}
            help={__(
              "In order to use Newsletter block, you need to use Mailchimp API.",
              "slideverse"
            )}
            id="slideverse-options-mailchimp-api"
            className="slideverse-button-field"
          >
            <TextControl
              type="text"
              label={__("API Key", "slideverse")}
              value={mailchimpAPI}
              placeholder={__("Mailchimp API Key", "slideverse")}
              onChange={(value) => setMailchimpAPI(value)}
            />

            <TextControl
              type="text"
              label={__("AUDIENCE ID", "slideverse")}
              value={mailchimpAudienceID}
              placeholder={__("Mailchimp Audience ID", "slideverse")}
              onChange={(value) => setMailchimpAudienceID(value)}
            />

            <div className="slideverse-button-group">
              <Button
                variant="secondary"
                className="ubs-action-button"
                isSecondary
                onClick={() => {
                  updateOption("slideverse_mailchimp_api_key", mailchimpAPI);
                  updateOption(
                    "slideverse_mailchimp_audience_id",
                    mailchimpAudienceID
                  );
                }}
              >
                {__("Save", "slideverse")}
              </Button>

              <ExternalLink href="https://mailchimp.com/">
                {__("Get API Key", "slideverse")}
              </ExternalLink>
            </div>
          </BaseControl>
        </PanelRow>
      </PanelBody>
    </>
  );
};

export default integrations;
